import { WizAgGrid } from './wiz-ag-grid.component';
import { AgGridModule } from 'ag-grid-angular';
import { NgModule } from '@angular/core';

@NgModule({
  declarations: [
    WizAgGrid
  ],
  imports: [
    AgGridModule
  ],
  exports: [
    WizAgGrid
  ]
})
export class WizAgGridModule {

}
